import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_gori/helpers'

export function CILFPromoBanner() {
  const intl = useIntl()

  return (
    <section className='cilf-promo-banner position-absolute top-0 w-100 bg-primary-dark d-flex flex-row flex-wrap gap-6 justify-content-center align-items-center p-5'>
      <img
        className='d-block m-0'
        src={toAbsoluteUrl('/media/logos/shipbae-logo-white.webp')}
        alt='ShipBae'
        width='120'
        height='28.571'
      />
      <p className='banner-desc fw-bolder text-white text-center m-0'>
        {intl.formatMessage({id: 'CILF2025_PROMO_BANNER_15'})}
      </p>
    </section>
  )
}
